module.exports = __webpack_public_path__ + "img/icon-home-re-02.40173dbd.jpg";